exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Collapsible__content[data-v-98a2b5c4]{overflow:hidden}.Collapsible__contentInner[data-v-98a2b5c4]{height:auto}.Collapsible__trigger[data-v-98a2b5c4]{appearance:none;border:0;background:transparent;border-radius:0;font-family:inherit;font-size:inherit;font-style:inherit;text-align:inherit;color:inherit;padding:0;margin:0;display:block;width:100%;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-98a2b5c4","scoped":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./App/Shared/Collapsible.vue
// module id = 1088
// module chunks = 0